import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIcnDownArrow = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={10} fill="currentColor" viewBox="0 0 24 24" {...props}><Path d="M0 7.33 2.829 4.5l9.175 9.339L21.171 4.5 24 7.33 12.004 19.5z" /></Svg>;
const Memo = memo(SvgIcnDownArrow);
export default Memo;